export const SETTLEMENT_TOKEN_KEY = "@Settlement";
